export const data = [
  {
    _id: "670fb826e6351de92c12e392",
    name: "Fpv drone",
    club: "670fa7720c1974ea2bfbc8c7",
    eventId: "EYANTRAFD",
    clubName: "E-YANTRA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729083429/TechKriya%2724/ijwakol6hx7qlizlx8hx.jpg",
    description:
      "Flying an FPV (First-Person View) drone offers a thrilling experience, immersing the pilot in real-time visuals from the drone's perspective. Equipped with cameras and video goggles, pilots navigate with precision, performing aerial maneuvers, racing, or capturing breathtaking footage, making it a popular hobby for drone enthusiasts.",
    coins: 20,
    registered_users: ["670ec5b4021a74e504525375"],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670f9f5e0c1974ea2bfbc863",
    name: "Tech Odyssey",
    club: "670f9ec60c1974ea2bfbc85e",
    eventId: "GCTO",
    clubName: "GC",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729077085/TechKriya%2724/pccfby9tluxw8bknjqxz.jpg",
    description:
      "In this exciting and interactive event, participants will embark on a\njourney to explore various clubs and associations across campus.\nEach group will receive a card containing a clue, leading them to\nidentify and visit their first assigned club. Upon arrival, participants will\nengage in activities organized by the club, after which a club member\nwill stamp their card as proof of completion.\nThe club will then provide the hint to the next destination. Participants\nmust complete a series of three clubs, collecting stamps along the way.\nOnce finished, they will return to the Graphic Cafe room to solve a final\nset of clues and questions. Successfully solving the puzzle will unlock the ultimate reward— a gift for the winning team.\nThis event encourages collaboration, exploration, and quick thinking,\nmaking it a fun and rewarding challenge for all involved!",
    coins: 20,
    registered_users: ["670ec5b4021a74e504525375"],
    visited_users: ["670ec5b4021a74e504525375"],
    __v: 0,
  },
  
  {
    _id: "670fb519e6351de92c12e35b",
    name: "TechQuest \nFrenzy",
    club: "670fa62b0c1974ea2bfbc8c3",
    eventId: "I&ETF",
    clubName: "I&E CELL",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729202220/20241018_030028_0000_oniivv.jpg",
    description:
      "It is an engaging event which captivates and challenges the \nparticipants through a dynamic blend of technology, entertainment, and \nrapid thinking. It will contain different technical question which test the \nparticipant’s knowledge in different aspects of engineering and \ninnovation, which will give them a way out of the puzzle maze. In \nsubsequent rounds the participants will go through “Technical Meme \nMania” and rapid-fire rounds.",
    coins: 20,
    registered_users: ["670ec5b4021a74e504525375"],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fd682e6351de92c12e554",
    name: "Lumina Dash",
    club: "670fd4dae6351de92c12e529",
    eventId: "IEECLD",
    clubName: "IEEE",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729091199/TechKriya%2724/tajikw5mneumi5s8txlu.jpg",
    description:
      "Lumina Dash is an engaging game where the players will have to \ntraverse through obstacles and make sure they never touch the laser. \nNew challenges will be included as they complete each level. \n",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "6710ef054b467c29ab163565",
    name: "The Fluid\nMaze",
    club: "6710ec1d7169b38b74817273",
    eventId: "ChEATFM",
    clubName: "ChEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729163013/TechKriya%2724/fjvdj6cpopyv3qux0kdb.jpg",
    description:
      'The Fluid Maze is an interactive game that challenges participants to\nsolve a pipeline maze by operating valves and managing fluid flow.\nThis hands-on activity simulates fluid mechanics and dynamics\nprinciples, requiring players to apply critical thinking and problem-\nsolving skills to navigate the maze successfully. Including "The Fluid\nMaze" in Techkriya will enhance the tech fest by merging educational\ncontent with interactive fun. The game offers a practical understanding\nof fluid mechanics while encouraging teamwork and innovation',
  },
  {
    _id: "6710f1184b467c29ab16356c",
    name: "Chem-E-Car",
    club: "6710ec1d7169b38b74817273",
    eventId: "ChEACEC",
    clubName: "ChEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729163544/TechKriya%2724/bou5n9lhvl21t2nf7omu.jpg",
    description:
      "Chem-E-Car is an innovative technical event where participants will\ndesign and build a working car model powered by the principles of an\nelectrolytic cell. In this project, the car will be propelled using a\ncombination of various electrolytes, such as Copper Sulphate (CuSO₄),\nSilver Nitrate (AgNO₃), and Zinc Sulphate (ZnSO₄). The event will\nshowcase the practical application of electrochemical reactions,\nenergy conversion, and the integration of chemical engineering\nconcepts in real-world problem-solving. This event will provide hands-\non challenge, where science, creativity, and engineering come together\nto drive innovation",
  },
  {
    _id: "6710f1d14b467c29ab163571",
    name: "Viscosolve",
    club: "6710ec1d7169b38b74817273",
    eventId: "ChEAV",
    clubName: "ChEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729163729/TechKriya%2724/ithhe1cmt60l1vs8ab3d.jpg",
    description:
      "Viscosolve is an interactive team-based challenge that requires\nparticipants to solve a problem without being able to see themselves.\nWorking with their teammates through communication only, players\nmust tackle a problem statement given at the beginning. A key clue,\nhidden in a tub of non-Newtonian fluid, must be uncovered to solve the\npuzzle. This hands-on activity brings together critical thinking,\ncollaboration, and the fascinating properties of fluid dynamics.\nIncluding Viscosolve in Techkriya will elevate the tech fest by merging educational content with interactive fun, promoting teamwork,\ninnovation, and practical problem-solving skills.",
  },
  {
    _id: "6710f4774b467c29ab163576",
    name: "Laser Tag",
    club: "670a37c3a7fe4650bb4c5b0c",
    eventId: "ECEALT",
    clubName: "ECEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729164407/TechKriya%2724/hn4t3eqcyp42sg3htcr1.jpg",
    description:
      "Gear up for an adrenaline-pumping Laser Tag Adventure! Join us for\nan epic battle in a thrilling arena filled with obstacles and challenges.\nGather your friends and strategize your way to victory as you dodge,\nshoot, and compete for the ultimate bragging rights !",
  },
  {
    _id: "6710f52d4b467c29ab16357b",
    name: "Project &\nPaper\nPresentations",
    club: "670a37c3a7fe4650bb4c5b0c",
    eventId: "ECEAPPP",
    clubName: "ECEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729164589/TechKriya%2724/xyyjdyrt5i6fu3pcdp5t.jpg",
    description:
      '"Project & Paper Presentations" offers a platform for students to\nshowcase their innovative projects and research papers at Techkriya.\nThis event provides an opportunity for participants to present their\nwork, share insights, and gain feedback from peers and experts alike.\nWhether it\'s a hands-on engineering project or an academic research\npaper, students can highlight their creativity, technical skills, and\nresearch capabilities. This event not only fosters innovation but also\nencourages collaborative learning and knowledge sharing within the\nstudent community.',
  },
  {
    _id: "670f968e0c1974ea2bfbc829",
    name: "C2S: Circuit to\nSky",
    club: "670a37c3a7fe4650bb4c5b0c",
    eventId: "ECEAC2S",
    clubName: "ECEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729074829/TechKriya%2724/u0rpww3pffdu0p4bhstj.jpg",
    description:
      'C2S: Circuit to Sky" takes you through an immersive journey into the\nheart of Electronics and Communication Engineering (ECE) at\nTechkriya. The event will showcase key ECE technologies, starting\nwith an in-depth exploration of silicon wafers, ATmega328P\nmicrocontrollers, Arduino development boards, and brushless motors,\nproviding a foundational understanding of how these components\npower modern devices. Additionally, a disassembled smartphone will\nbe displayed, allowing attendees to learn about its core parts such as\nthe processor, sensors, and communication modules and how they\nwork together to deliver functionality.\nThe event culminates in a live demonstration of an FPV drone, which\nbrings together all these technologies into a single, practical\napplication. By integrating components like microcontrollers, motors,\nand communication systems, the drone exemplifies how the knowledge\ngained in ECE is applied to build complex, innovative products. "C2S:\nCircuit to Sky" offers a comprehensive learning experience that\nconnects theory to real-world engineering, making it an exciting and\nvaluable addition to Techkriya',
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670f979b0c1974ea2bfbc82e",
    name: "Car Soccer",
    club: "670a37c3a7fe4650bb4c5b0c",
    eventId: "ECEACS",
    clubName: "ECEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729075099/TechKriya%2724/hkjtcgvmng85rcx9q0ry.jpg",
    description:
      "Join us for an exhilarating RC Car Football Showdown! Watch as\nremote-controlled cars navigate the field, dribble, and score goals in\nthis unique twist on the classic game. Bring your friends and cheer on\nyour favourite team in this action-packed event!",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670f98b70c1974ea2bfbc836",
    name: "Circuit Saga",
    club: "670a37c3a7fe4650bb4c5b0c",
    eventId: "ECEACSA",
    clubName: "ECEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729075383/TechKriya%2724/bprzekcude9batbreiip.jpg",
    description:
      "This event is a thrilling hands-on challenge at Techkriya, designed\nto test and enhance participants' circuit design and problem-solving\nskills. In this event, participants will be provided with breadboards, ICs,\nand connecting wires, and will be tasked with implementing a Boolean\nfunction or circuit displayed on the Maxhub screen or blackboard. In a\nmore advanced variation, participants will receive a partially completed\ncircuit or one with intentional errors, and they must diagnose and rectify\nthe mistakes to create a functioning implementation. This event not\nonly sharpens technical skills but also promotes logical thinking and\nquick troubleshooting, making it an essential experience for aspiring\nengineers and enthusiasts alike ",
    coins: 20,
    registered_users: ["670ec5b4021a74e504525375"],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670f9a170c1974ea2bfbc840",
    name: "Project Expo",
    club: "670cf5a11072f0f86b48a793",
    eventId: "CSEAPE",
    clubName: "CSEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729075735/TechKriya%2724/f1gn1k9gry7alsofnt11.jpg",
    description:
      "Illustrating various projects on different technologies like OpenCV etc, where OpenCV can be used to build models that detect patterns, enhance image quality, or even predict future movements. Projects using OpenCV offer endless possibilities in fields like healthcare, automotive, and entertainment, providing an intuitive interface to tackle complex visual tasks.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670f9a500c1974ea2bfbc846",
    name: "Treasure Hunt",
    club: "670cf5a11072f0f86b48a793",
    eventId: "CSEATH",
    clubName: "CSEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729075791/TechKriya%2724/mqdndm3s6h1vdmtqw67u.jpg",
    description:
      "The participants are awarded points based on various tests like\ndebugging code, typing test, sudoku solving, memory game, puzzle\nsolving etc",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },

  {
    _id: "670fa00d0c1974ea2bfbc86e",
    name: "Immersia",
    club: "670f9ec60c1974ea2bfbc85e",
    eventId: "GCI",
    clubName: "GC",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729077261/TechKriya%2724/nbyuu1ozdehhpgcumxi9.jpg",
    description:
      "In this immersive event, participants will have the chance to dive into\nthe exciting world of Virtual Reality (VR) gaming, offering an experience\nthat blends cutting-edge technology with the thrill of exploration.\nAttendees will enter a simulated environment where they can engage\nin various VR games designed to challenge their cognitive skills,\nteamwork, and reflexes.\nThe event will feature multiple gaming stations equipped with VR\nheadsets, allowing participants to compete in individual and group\nchallenges.\nBy the end of the event, top players will be recognized and awarded\nspecial prizes based on their scores and achievements. This event not\nonly promises entertainment but also introduces attendees to the\npossibilities of VR technology in gaming and beyond.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fa2770c1974ea2bfbc883",
    name: "Vision",
    club: "670fa0f90c1974ea2bfbc879",
    eventId: "TFV",
    clubName: "TASKFORCE",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729077878/TechKriya%2724/gprngi2fs408ikgilotj.jpg",
    description:
      "Real time simulation of auctions using strategic thinking and managing\nthe capital",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fa35f0c1974ea2bfbc890",
    name: "Soak Pit",
    club: "670fa2e00c1974ea2bfbc88b",
    eventId: "CEASP",
    clubName: "CEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729078110/TechKriya%2724/xouquyu1fftjmaqb1wpo.jpg",
    description:
      "A soak pit is a simple, underground structure designed to manage wastewater by allowing it to slowly soak into the ground. It typically consists of a circular or square pit filled with coarse stones, gravel, or sand, which helps filter and disperse the water into the surrounding soil. Wastewater from sources like kitchen sinks, bathrooms, or septic tanks enters the pit and percolates through the porous materials, where impurities are naturally filtered out as the water seeps deeper into the ground. This process helps in groundwater recharge and prevents surface water contamination, making soak pits an effective solution for sustainable wastewater management.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fa4480c1974ea2bfbc898",
    name: "Earthquake\nResistant\nStructures",
    club: "670fa2e00c1974ea2bfbc88b",
    eventId: "CEAERS",
    clubName: "CEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729078343/TechKriya%2724/bhjhlpytixlnsgaencdx.jpg",
    description:
      "Earthquake Resistance Structures\nStudents will be provided with bamboo sticks/ ice cream sticks to\nconstruct a tall tower which can withstand the provided magnitude of\nvibration.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fa4ad0c1974ea2bfbc8a0",
    name: "Irrigation\nSystem",
    club: "670fa2e00c1974ea2bfbc88b",
    eventId: "CEAIS",
    clubName: "CEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729078444/TechKriya%2724/mlatyithkbpxxvu7lz4d.jpg",
    description:
      "Irrigation System This event will be a model of different irrigation\nsystems. This will demonstrate the flow of water through dams, and\nhow the water reaches the irrigation fields. This will add value to the\nstudent’s learning regarding various methods of irrigation. Further the\nsame model can be used for teaching demonstration .",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fa5720c1974ea2bfbc8ab",
    name: "Design Challenge",
    club: "670fa4e50c1974ea2bfbc8a6",
    eventId: "MEADC",
    clubName: "MEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729078642/TechKriya%2724/pwmgn3nox6jnc31ihqtd.jpg",
    description:
      "Need to design an object in a cad software. The guidelines will be given\nto model that object. For freshers we will demonstrate the design steps\nin easy manner",
    coins: 20,
    registered_users: ["670ec5b4021a74e504525375"],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fa5d80c1974ea2bfbc8b3",
    name: "Engine\nAnatomy",
    club: "670fa4e50c1974ea2bfbc8a6",
    eventId: "MEAEA",
    clubName: "MEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729078743/TechKriya%2724/xfrbmh6f80atj2nradco.jpg",
    description:
      "The section views of engine and other rotary motion will be shown.\nSimulation to show the working of those will be displayed",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fa9280c1974ea2bfbc8e9",
    name: "Marketing\nMania",
    club: "670fa62b0c1974ea2bfbc8c3",
    eventId: "I&EMM",
    clubName: "I&E CELL",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729199531/Marketing_Mania_esxp3v.jpg",
    description:
      '"Marketing Mania" is an engaging event at Techkriya where\nparticipants pitch innovative strategies to drive business growth. This\ncompetition enhances critical thinking, creativity, and practical\nmarketing skills. By simulating real-world scenarios, it adds value to\nTechkriya by fostering entrepreneurial spirit and encouraging strategic\ndecision-making in participants.',
    coins: 20,
    registered_users: ["670cbb298a767c99e162b55d"],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fb404e6351de92c12e351",
    name: "Visionary \nVoices",
    club: "670fa62b0c1974ea2bfbc8c3",
    eventId: "I&EVV",
    clubName: "I&E CELL",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729082371/TechKriya%2724/ofqqrl2tjgxvebwtismi.jpg",
    description:
      "Visionary Voices is a keynote event at Techkriya where renowned \nentrepreneurs and founders share their experiences, and strategies for \nsuccess. This event will inspire innovation and leadership among \nparticipants and enriches Techkriya's mission to promote creativity, \nentrepreneurship, and forward-thinking solutions.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fb625e6351de92c12e364",
    name: "Digital Da Vinci",
    club: "670fa7720c1974ea2bfbc8c7",
    eventId: "EYANTRADD",
    clubName: "E-YANTRA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729082916/TechKriya%2724/vtslcrhw97vnutvqbaxv.jpg",
    description:
      "Machines generate art by using algorithms, often AI-driven, to analyze patterns, colors, and forms from large datasets. Through models like GANs, they create unique pieces that mimic human creativity or invent new styles, blending technology and imagination to redefine artistic expression in the digital era.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },

  {
    _id: "670fbd4ce6351de92c12e3be",
    name: "Visual vibes \ndiscover the \nfest lineup",
    club: "670fbbe5e6351de92c12e3b9",
    eventId: "MCVV",
    clubName: "MAGAZINE CLUB",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729084746/TechKriya%2724/bw45jxgqvqulo8vfysra.jpg",
    description:
      "Visual Vibes\" is your ultimate guide in navigating the exciting array of \ntechnical activities, and events \nhappening across our campus during the technical fest. This event \nbrings you a comprehensive list of all \nongoing activities, conveniently mapped out and displayed through \nvibrant brochures, posters, and banners. \nWhether you're looking for hands-on technical sessions, or fun \nchallenges, Visual Vibes ensures you're \nalways informed and in the right place at the right time. \nStrategically placed throughout the venue, these visual guides act as \nyour go-to source for all event-related \ninformation, providing room numbers, time slots, and event details, so\nyou can plan your experience with \nease. Stay updated on the latest happenings and make the most of the \nfest by following the Visual Vibes!\n",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fbe90e6351de92c12e3d0",
    name: "Beyond the \nboundary",
    club: "670fbdfde6351de92c12e3c8",
    eventId: "PCBB",
    clubName: "Physical Education",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729085070/TechKriya%2724/gpawkotirm4acuruyfgp.jpg",
    description:
      "Step into the future of sports with our VR Cricket event! Experience the \nthrill of batting, bowling, and fielding in a fully immersive virtual \nenvironment. Using advanced VR technology, you can compete with \nother players in real-time, simulating a real cricket match in famous \nstadiums around the world. Whether you're a cricket pro or a VR \nenthusiast, this event promises to be a thrilling experience for \neveryone.\n",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fc010e6351de92c12e3ff",
    name: "Rc Car off \nroad \nchallenge",
    club: "670fbdfde6351de92c12e3c8",
    eventId: "PCRC",
    clubName: "Physical Education",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729085453/TechKriya%2724/c7ff6gsqgqadbfvgwch3.jpg",
    description:
      "Get ready to rev up your engines and conquer rugged terrains in our RC \nOff-Road Challenge! Participants will control remote-controlled \nvehicles through a challenging off-road course filled with obstacles like \nsteep hills, mud pits, and rocky paths. Precision driving, speed, and \nagility are key to navigating the course and outpacing your \ncompetitors. Whether you're a seasoned RC enthusiast or a beginner, \nthis event promises adrenaline-pumping action",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fc1cde6351de92c12e40b",
    name: "Deation on \nApplication of \nAI & ML in \nEnvironment",
    club: "670fc049e6351de92c12e405",
    eventId: "NVCDA",
    clubName: "NVE",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729085899/TechKriya%2724/g0pft7haumpxlmq9axb8.jpg",
    description:
      "Environmental challenges using artificial intelligence and machine \nlearning. Participants will present their solutions in the form of posters, \nand if applicable, demonstrate working prototypes. The event will focus \non identifying practical, impactful AI/ML-based approaches to problems \nsuch as climate change, waste management, wildlife conservation, and \nsustainable resource use. Faculty members will evaluate the solutions \nand provide feedback, with certificates awarded to all participants.\n",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fc331e6351de92c12e420",
    name: "Waste To \nWealth",
    club: "670fc049e6351de92c12e405",
    eventId: "NVCWT",
    clubName: "NVE",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729086255/TechKriya%2724/piylqjdml8rhevjzy3cp.jpg",
    description:
      'The "Waste to Wealth" event is a creative initiative aimed at \ntransforming waste materials into valuable and functional products. \nParticipants will be provided with various waste materials and will have \nthe opportunity to design and create innovative items using these \nmaterials. This event not only promotes creativity and sustainability but \nalso raises awareness about the importance of recycling and reusing \nwaste materials',
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fc3a2e6351de92c12e425",
    name: "Origami",
    club: "670fc049e6351de92c12e405",
    eventId: "NVCO",
    clubName: "NVE",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729086368/TechKriya%2724/dxot4onornoczvk2uh3v.jpg",
    description:
      "Origami is an event that celebrates the blend of art and nature, inviting \nparticipants to explore natural beauty through the ancient craft of \norigami. This eco-friendly activity fosters mindfulness, creativity, and \nenvironmental awareness by using recyclable paper to create detailed \nsculptures inspired by plants and animals. The event will feature \n",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fc429e6351de92c12e42d",
    name: "Bioseed \nWater \nCleanse",
    club: "670fc049e6351de92c12e405",
    eventId: "NVEBC",
    clubName: "NVE",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729086503/TechKriya%2724/doo2i4ud33nph06cmpa4.jpg",
    description:
      "Bio Seed Water Cleanse is an exhibition that delves into the \nremarkable capacity of natural seeds—such as neem, papaya, and \nmoringa—to purify water by effectively eliminating impurities, bacteria, \nand pollutants. This event emphasizes the eco-friendly and sustainable \naspects of seed-based water treatment, offering not only live \ndemonstrations but also in-depth discussions of the scientific principles \nunderpinning this method. Furthermore, participants will gain practical \nknowledge on how to implement these techniques in real-world \nscenarios. The event will also spotlight aquatic plants like water \nhyacinth, reeds, and duckweed, which play a vital role in enhancing \nwater quality by absorbing pollutants. Overall, it provides an enriching \nopportunity to explore nature's profound and simple solutions for \nachieving cleaner and safer water.\n",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fc5a0e6351de92c12e43a",
    name: "MUSIC \nUNPLUGGED",
    club: "670fc4d1e6351de92c12e435",
    eventId: "DHWANIMU",
    clubName: "Dhwani",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729086878/TechKriya%2724/uwg91gc1unc2mgvykmc2.jpg",
    description:
      "we take you on a journey through the world of musical instruments and \nmodern music software. Whether you are a musician, a tech \nenthusiast, or simply curious about the magic behind your favourite \ntunes, this event has something for everyone! In the first half of the \nsession, we will explore the fundamentals of various musical \ninstruments—guitars, keyboards, drums, and more. Experienced \nmusicians of our club will demonstrate how these instruments produce \nsound and the techniques used to create different tones and effects. \nSimultaneously, in the second half, we'll dive into music software such \nas Digital Audio Workstations (DAWs). You'll get a live demonstration \nof how technology is used to record, edit, and mix sounds, combining \nthem to create full compositions. We'll discuss the role of MIDI \ncontrollers, virtual instruments, and plug-ins, offering insight into how \nmodern musicians blend traditional instrument playing with digital \nproduction.\nBy the end of the event, you'll have a better understanding of how to \ncreate, manipulate, and innovate music, using both hands-on \ninstruments and cutting-edge technology. Whether you're interested in \nperforming live or producing tracks, this session will open doors to new \npossibilities in music creation.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fc63ae6351de92c12e442",
    name: "Synchro \nVerse",
    club: "670fc4d1e6351de92c12e435",
    eventId: "DHWANISC",
    clubName: "Dhwani",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729087032/TechKriya%2724/y7k6qmfcrrzhbtfmoddd.jpg",
    description:
      "This event will integrate cutting-edge Virtual Reality technology with the \ntimeless joy of live music performances, creating an immersive \nexperience like never before.\nImagine stepping into a concert hall, feeling the energy of the crowd, \nand watching iconic performances as if you were really there—without \never leaving the campus! In this event, participants will be able to enjoy \nconcerts by globally renowned bands such as BTS, Blackpink, and \nColdplay. Additionally, we’ll feature celebrated Tollywood artists like \nKarthik and Shreya Ghoshal & Arijit Singh.\nThrough the use of VR headsets, attendees will step into a virtual arena \nwhere these concerts will unfold in real time, simulating the sensation \nof attending a live event. Whether it’s feeling the thumping beats or the \nintricate melodies of your favourite songs, this immersive VR \ntechnology will transform how music lovers experience concerts. By\nthe end of the event, participants will have experienced a revolutionary \nnew way to enjoy music concerts, blending technology with the art of \nlive performance. Whether you are a die-hard fan of any of the artists \nor just curious about VR, this event is set to redefine how you \nexperience music",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fc6fae6351de92c12e44a",
    name: "The Material \nMatrix",
    club: "670fc665e6351de92c12e445",
    eventId: "MMEATM",
    clubName: "MMEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729087223/TechKriya%2724/gwdpnopjaeuwx198yasr.jpg",
    description:
      'The Material Matrix" is an engaging and interactive material science \nexhibition designed to unravel the fascinating world of materials. \nThrough captivating demonstrations, simple yet impactful experiments, \nand visual displays, participants will explore the diverse properties and \napplications of various materials in real-world scenarios. The exhibition \naims to inspire curiosity and provide insights into how metallurgical and \nmaterial sciences shape innovation and technology. Whether you\'re a \nbudding engineer or simply curious, "The Material Matrix" offers \nsomething for everyone, bridging the gap between science and \neveryday life.',
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fc764e6351de92c12e450",
    name: "Cast & Quiz \nConclave",
    club: "670fc665e6351de92c12e445",
    eventId: "MMEAC",
    clubName: "MMEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729087330/TechKriya%2724/mr5c4mviwv1km02l2msb.jpg",
    description:
      'The "Cast and Quiz Conclave" is a dynamic event celebrating the \nintricacies of metallurgy and materials science. The morning session \nfeatures hands-on casting activities, providing participants with a \nunique opportunity to explore the art and science of metal casting. In \nthe afternoon, the focus shifts to a stimulating quiz, testing knowledge \non metallurgy and material science topics. The event concludes with \ninsightful presentations from students of various colleges, showcasing \nresearch and developments in the field. This conclave serves as a \nplatform for learning, competition, and knowledge sharing among \nbudding metallurgists.',
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fca0ae6351de92c12e465",
    name: "Blurry Eyed \nPictionary",
    club: "670fc7bfe6351de92c12e456",
    eventId: "L&DBE",
    clubName: "L&D",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729088007/TechKriya%2724/q4x1kxq5a3bot0t7mlft.jpg",
    description:
      "The Blurry Eyed Pictionary is an innovative version of the traditional \nPictionary with a Literary twist, where the participants will have to \ncompete against each other by drawing on a blank sheet while having \na blurry vision. The participants need to have good knowledge in \nfamous poems & paintings in order to make the best guesses. The \ntopics and poems will be generated using a LLM model tuned to the \nusers’ preferences. The objective is to help your team guess the word \nbefore the other team. This event sparks the competitive spirit, \ndemands artistic skills and also helps participants gain new knowledge. \nWinner will be decided by the best of 3 rounds.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fca93e6351de92c12e46c",
    name: "Spoonerism",
    club: "670fc7bfe6351de92c12e456",
    eventId: "L&DS",
    clubName: "L&D",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729088144/TechKriya%2724/hvukoroc3alf8clsiu72.jpg",
    description:
      "AI generated spoonerism is a game in which words are stripped down \nto basic vowel sounds (Example: Grape is written as Grey + App, \nLibrary is Lie + Berry) using LLMs. Participants require a deep \nknowledge of vocabulary and understanding of phonetics in order to \nprevail. With the use of creativity and quick thinking this game helps \nmake words more interesting and fun for the participants.\n",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fcb69e6351de92c12e478",
    name: "The Art and \nLight \nExperience .",
    club: "670fcadce6351de92c12e473",
    eventId: "P&PTA",
    clubName: "P&P",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729088357/TechKriya%2724/h5ousxf1tcd7uzvvohzx.jpg",
    description:
      "The Art and Light Experience\nOur club will spearhead the decoration for Techkriya 2024, \ntransforming the venue into a vibrant and visually stunning space. The \ndecoration will incorporate four key elements:\nDynamic Lighting Displays: Strategically placed lighting installations \nwill enhance the ambiance of the event, creating an immersive and \nenergetic environment. The lighting will highlight key areas, ensuring \nthe venue is visually engaging and exciting for attendees.\nInteractive Photo Booths: Creative photo booths, designed with artistic \nbackdrops and themed props, will allow attendees to capture \nmemorable moments. These interactive booths will add a fun and \nparticipatory element, encouraging engagementknowledge of vocabulary and understanding of phonetics in order to \nprevail. With the use of creativity and quick thinking this game helps \nmake words more interesting and fun for the participants.\n",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fcda3e6351de92c12e486",
    name: "Biotech \nStartup\n",
    description: "This biotech startup technical event focuses on innovation and emerging technologies in the biotechnology sector. It brings together entrepreneurs, researchers, and industry experts to explore cutting-edge solutions in healthcare, agriculture, and environmental sustainability. The event aims to showcase breakthroughs, foster collaboration, and provide a platform for startups to connect with potential investors and partners, accelerating the growth of biotech ventures.",
    club: "670fcba8e6351de92c12e47c",
    eventId: "BTHG",
    clubName: "BEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729088927/TechKriya%2724/n2b27azhezr8yuuuoi6i.jpg",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fce84e6351de92c12e4a0",
    name: "Marvelous \nScience",
    club: "670fcba8e6351de92c12e47c",
    eventId: "BTHM",
    clubName: "BEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729089153/TechKriya%2724/ejfwmoyiot3ubrezeda1.jpg",
    description:
      "It’s a fun event to inspire student towards the world of Biotechnology \nand science which includes knowledge of Biotech different terminology, \nmechanism and metabolism.",
    coins: 20,
    registered_users: ["670ec5b4021a74e504525375"],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fcf62e6351de92c12e4cc",
    name: "Hybrid Growth \nMonitor of \nfungal culture \nusing IoT",
    club: "670fcba8e6351de92c12e47c",
    eventId: "BTHMA",
    clubName: "BEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729089376/TechKriya%2724/km1xmubxleiibg7i55js.jpg",
    description:
      "The event involves demonstration of a smart monitoring system for \nfungal culture growth inside a controlled environment box. The box, \nmade of cardboard, contains various sensors to track key \nenvironmental parameters: temperature (DHT22/LM35), humidity \n(DHT22), CO2 levels (MH-Z19B), light (LDR/optical sensors), and pH \n(pH probe). These sensors are connected to a microcontroller \n(Arduino/Raspberry Pi/ESP32), which logs and analyses data. \nVentilation fans and light sources help maintain optimal conditions, \nwhile a camera provides real-time or time-lapse imaging. The setup \nallows for precise monitoring and control of fungal growth, with data \nvisualization through a display or IoT platform for remote access. This \nevent will enhance the technical fest by showcasing an innovative use \nof IoT and biotechnology to monitor fungal growth in real-time. \nAttendees will experience the integration of sensors, automation, and \ndata analysis in a biological setting, highlighting the relevance of smart \nsystems in research and industry applications like agriculture and \nmicrobiology, making it a standout, hands-on exhibit.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fd064e6351de92c12e4d4",
    name: "SHORT FILM",
    club: "670fcf82e6351de92c12e4cf",
    eventId: "CHITRAMSH",
    clubName: "CHITRAM",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729180677/lw_ngxgou.jpg",
    description:
      "Shadows of Valor is a poignant short film set against the harrowing \nbackdrop of World War II. The film delves into the intense psychological \nstruggles faced by soldiers as they navigate the brutal realities of war. \nThrough a series of interconnected vignettes, the story paints a vivid \nportrait of the soldiers’ mental battles, revealing the profound impact of \ncombat on their emotional and psychological well-being. ",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fd141e6351de92c12e4e3",
    name: "Eco \nPainting",
    club: "670fd093e6351de92c12e4de",
    eventId: "BRINDAVANEP",
    clubName: "Brindavanam",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729089855/TechKriya%2724/dkzer6yazems60uewlcs.jpg",
    description:
      "Eco Painting is a natural dyeing technique where plant materials such \nas leaves, flowers, and stems are used to create prints on fabric or \npaper. This process involves placing plant material directly onto the \nsurface to be printed, then bundling it tightly and applying heat, \nmoisture, and pressure to transfer the natural pigments and shapes \nfrom the plants onto the surface.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fd171e6351de92c12e4e8",
    name: "Green \nBreath",
    club: "670fd093e6351de92c12e4de",
    eventId: "BRINDAVANGP",
    clubName: "Brindavanam",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729089903/TechKriya%2724/tuqdcsygnnhca6hy8oig.jpg",
    description:
      "Green Breath is an event dedicated to showcasing the power of airpurifying plants. Discover how simple, beautiful greenery can transform \nindoor spaces by improving air quality, reducing pollutants, and \nenhancing overall well-being",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fd4b0e6351de92c12e526",
    name: "Electro \nGallery",
    club: "670fa84b0c1974ea2bfbc8df",
    eventId: "EEEAEG",
    clubName: "EEEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729090733/TechKriya%2724/i1bjl0rbaplsdmaro9gn.jpg",
    description:
      "The ELECTRO GALLERY will serve as a museum showcasing the \nevolution and trends in electrical and electronics engineering. This \nevent will provide educational value and inspire attendees with the \nadvancements in the field.\n",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670fd554e6351de92c12e533",
    name: "IEEE Chase",
    club: "670fd4dae6351de92c12e529",
    eventId: "IEECHA",
    clubName: "IEEE",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729090898/TechKriya%2724/atrnjmyiptkzora9rt4x.jpg",
    description:
      "An engaging event that combines exploration, problem-solving, and \ninnovation. Participants will navigate through an interactive IEEE \ngallery while engaging in a treasure hunt and solving IEEE-themed \ncrossword puzzles. This event aims to enhance understanding of \ntechnological advancements and the impact of IEEE on various fields",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },

  {
    _id: "670ff191e6351de92c12e60e",
    name: "Jungle Safari",
    club: "670d0ed2ea7be0b3fe02277d",
    eventId: "AIRJS",
    clubName: "AI&R",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729098127/TechKriya%2724/uyyv07bs87dj1pwombqw.jpg",
    description:
      "A jungle safari is an adventurous journey through dense forests and wildlife reserves, offering an opportunity to observe animals in their natural habitats. Typically conducted in jeeps, open vehicles, or on foot with trained guides, a jungle safari allows participants to explore the rich biodiversity of a region. Visitors may encounter a variety of wildlife, such as elephants, tigers, leopards, birds, and exotic plant species. Safaris often focus on conservation and environmental awareness, providing a thrilling yet educational experience in the heart of nature, making it ideal for wildlife enthusiasts and nature lovers.",
    coins: 20,
    registered_users: [
      "670cbb298a767c99e162b55d",
      "670cbb298a767c99e162b55d",
      "6710224e0321e38ed1757c04",
      "670ec5b4021a74e504525375",
    ],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670ff420e6351de92c12e622",
    name: "Micro Mouse",
    club: "670d0ed2ea7be0b3fe02277d",
    eventId: "AIRMM",
    clubName: "AI&R",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729098781/TechKriya%2724/jx2m8c7f85ujhjqgfson.jpg",
    description:
      "A Micromouse is a small, autonomous robot designed to navigate and solve mazes. It is equipped with sensors to detect walls, motors for movement, and microcontrollers to process data and make decisions. The robot maps the maze as it explores, using algorithms like flood-fill to find the shortest path to the center. Micromouse competitions challenge participants to build robots that can solve mazes quickly and efficiently, combining skills in robotics, programming, and algorithm development. These events are popular in robotics education and innovation.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670ff62ee6351de92c12e629",
    name: "Autonomous DRONE",
    club: "670d0ed2ea7be0b3fe02277d",
    eventId: "AIRMAD",
    clubName: "AI&R",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729099307/TechKriya%2724/e9xazx0jekgnsbcwqlpu.jpg",
    description:
      "An autonomous drone is an unmanned aerial vehicle (UAV) capable of flying and completing tasks without human intervention. It relies on advanced technologies like artificial intelligence, GPS, sensors, and pre-programmed software to navigate, avoid obstacles, and adapt to environmental conditions. These drones can perform missions such as surveillance, mapping, inspection, delivery, and agricultural monitoring. Autonomous drones are widely used in industries like logistics, agriculture, defense, and emergency response, offering precision, efficiency, and the ability to operate in remote or hazardous areas with minimal human input.",
    coins: 20,
    registered_users: ["670ec5b4021a74e504525375"],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670ff6aee6351de92c12e630",
    name: "Line Follower",
    club: "670d0ed2ea7be0b3fe02277d",
    eventId: "AIRMLF",
    clubName: "AI&R",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729099436/TechKriya%2724/ewf8z7ryvihqin95ix2h.jpg",
    description:
      "A line follower is a type of autonomous robot designed to follow a predefined path, typically a black line on a white surface or vice versa. It uses sensors, often infrared or optical, to detect the line's contrast with the surrounding area. The robot continuously adjusts its direction to stay on course, making it ideal for applications in automation, such as in warehouses or factories. By following the line's path, these robots can transport objects, assist in sorting processes, or perform repetitive tasks efficiently without human intervention. Line followers are a fundamental concept in robotics education and development.",
    coins: 20,
    registered_users: ["670ec5b4021a74e504525375", "6710224e0321e38ed1757c04"],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "670ff994e6351de92c12e647",
    name: "Mini Drone",
    club: "670d0ed2ea7be0b3fe02277d",
    eventId: "AIRMD",
    clubName: "AI&R",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729100177/TechKriya%2724/vprxc0zt4pnbz5yofzjh.jpg",
    description:
      "A mini drone is a compact, lightweight unmanned aerial vehicle (UAV) designed for easy use and portability. Typically smaller than standard drones, mini drones are often equipped with basic cameras, sensors, and intuitive controls, making them ideal for recreational flying, aerial photography, or learning drone piloting. Their small size allows for indoor flight and easy navigation in tight spaces. Despite their scale, many mini drones offer features like real-time video transmission (FPV), altitude hold, and stable flight, making them popular among beginners, hobbyists, and even professionals for casual flying or practice.",
    coins: 20,
    registered_users: [],
    visited_users: [],
    __v: 0,
  },
  {
    _id: "671127eba1d2415f4fac1fc7",
    name: "Laser Trap",
    club: "670fa84b0c1974ea2bfbc8df",
    eventId: "EEEALT",
    clubName: "EEEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729177579/TechKriya%2724/nfpypowbaetx4o8suucs.jpg",
    description:
      '"Laser Trap: Navigate, Break the Beam, Defuse the Circuit"\n\nLaser Trap is an exciting two-round competition where three participants face off to test their skills. In the first round, they must complete a buzz wire circuit within a set time. In the second round, participants navigate a challenging laser maze while collecting clues along the way. These clues are essential to uncover the password needed to disable an Arduino-based circuit bomb waiting at the end of the maze. The fastest and most precise competitor wins the game by diffusing the “bomb” before time runs out',
    coins: 20,
  },
  {
    _id: "6711292673f7c8b8e5c2866f",
    name: "FunWEE room",
    club: "670fa84b0c1974ea2bfbc8df",
    eventId: "EEEATFR",
    clubName: "EEEA",
    image:
      "https://res.cloudinary.com/dei7js4nc/image/upload/v1729177892/TechKriya%2724/oyvrmmubivhefkghrows.jpg",
    description:
      "The FUNWEE ROOM offers an engaging, hands-on exploration of electrical systems. Participants will assemble devices, generate electricity, and work with advanced tech like RC cars and swarm drones. These interactive activities foster innovation and practical learning, enhancing the Techkriya experience.",
  },
];
// export const eventNamesAndIds = data.map((event) => {
//   return { name: event.name, eventId: event.eventId };
// });

// console.log(eventNamesAndIds);